import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useCreateEventReceptionMutation } from '@domains/orchestrator-pricing-committee';
import { getEditorPayload } from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';
import { useSelectedWorkflowStep } from '@domains/orchestrator-pricing-committee/hooks/useSelectedWorkflowStep';

export const EditorSubmitButton = () => {
  const { step } = useSelectedWorkflowStep();
  const payload = useSelector(getEditorPayload);

  const [createEventReception, { isLoading, isSuccess, isError }] =
    useCreateEventReceptionMutation();

  const handleClick = () => {
    if (!step) return;
    createEventReception(payload as any);
  };

  if (isError) toast.error('Error recibiendo el evento');
  if (isSuccess) toast.success('Evento recibido correctamente');

  if (!step) return null;

  return (
    <Button
      className="btn-habi"
      onClick={handleClick}
      disabled={isLoading}
      data-testid="editor-submit-button"
    >
      Enviar evento
    </Button>
  );
};
